import { createContext, use } from 'react'

export const DealPipelineContext = createContext(null)

export function useDealPipeline() {
  const context = use(DealPipelineContext)
  if (!context) throw new Error('useDealPipeline must be used inside DealPipelineProvider')

  return context
}

export function useOptionalDealPipeline() {
  return use(DealPipelineContext)
}
